import React, { useEffect, useState } from 'react';
import { API } from '../api';
import ProductMetricsGrid from './ProductMetricsGrid';

const ProductMetricsTab = () => {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const result = await API.stats.getProductMetrics();
      if (result.success) {
        setMetrics(result.data);
      }
      setLoading(false);
    };

    load();
  }, []);

  return (
    <div className="tab-content">
      <ProductMetricsGrid metrics={metrics} loading={loading} />
    </div>
  );
};

export default ProductMetricsTab;

